export default "__VITE_ASSET__FptLg0To__"